import React from 'react';
import { MarketingNav } from './MarketingNav';
import { MarketingFooter } from './MarketingFooter';
export function MarketingLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen bg-[#050505] text-gray-200 font-sans selection:bg-amber-500/30 flex flex-col" data-id="element-198">
      <MarketingNav data-id="element-199" />
      <main className="flex-1 pt-20" data-id="element-200">{children}</main>
      <MarketingFooter data-id="element-201" />
    </div>;
}